import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { BASE_URL_IMG, DAYS, slotDuration } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../hooks/useLogout";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
  UserAvatar,
} from "../../components/Component";
import {
  Badge,
  Card,
  CardBody,
  CardImg,
  CardText,
  CardTitle,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import CenterImage from "../../MyComp/UI/form/CenteImage";
import classnames from "classnames";

import { findUpper } from "../../utils/Utils";
import { Link } from "react-router-dom";
import {
  createDoctorSlotAPI,
  createDoctorSlotOfflineAPI,
  createMultipleClinicOfflineAPI,
  getDoctorSlotAPI,
  getZipDetailsAPI,
  removeClinicAPI,
} from "../../api/doctor";
import { toast } from "react-toastify";
import MyLoader from "../../MyComp/UI/form/MyLoader";
import { useWatch } from "react-hook-form";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SESSIONS = ["morning", "afternoon", "evening", "night"];

const DoctorSlotForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const doctor = location?.state?.data;
  const [activeTab, setActiveTab] = useState("offline");
  const [activeDay, setActiveDay] = useState("monday");
  const [clinics, setClinics] = useState([]);
  const [isClinicOpen, setIsClinicOpen] = useState(false);
  const [clinicRemoveConfirm, setClinicRemoveConfirm] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [api, setApi] = useState([]);
  const [loading, setLoading] = useState(true);
  const toggle = (tab) => {
    setActiveTab(tab);
  };
  const to12Hour = (time) => {
    if (!time) return "";
    let [hour, minute] = time.split(":");
    hour = parseInt(hour);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  // Default structure for offline slots that matches API response
  const defaultSlotStructureOffline = {
    // duration: "",
    // start_time: "",
    // end_time: "",
    fees: "",
    clinic_name: "",
    phone: "",
    clinic_address: "",
    emergency_fees: "",
    pin_code: "",
    // session: null,
    image_url_1: null,
    image_url_2: null,
    image_url_1_pre: null,
    image_url_2_pre: null,
    time: "",
    id: null,
  };

  const defaultValuesOffline = {
    slots: defaultSlotStructureOffline,

    to_all_offline: false,
  };
  const defaultSlotStructureTime = {
    start_time: "",
    end_time: "",
    duration: "",
  };

  const defaultValuesTime = {
    slots: DAYS.reduce((acc, day) => {
      acc[day] = [{ ...defaultSlotStructureTime }];
      return acc;
    }, {}),
    to_all_time: false,
  };

  //time form
  const {
    getValues: getValueTime,
    register: registerTime,
    handleSubmit: handleSubmitTime,
    control: controlTime,
    setValue: setValueTime,
    watch: watchTime,
    trigger: triggerTime,
    formState: { errors: errorsTime },
    reset: resetTime,
  } = useForm({
    defaultValues: defaultValuesTime,
    mode: "onChange",
  });
  const {
    fields: timeFields,
    append: appendTime,
    remove: removeTime,
    replace: replaceTime,
  } = useFieldArray({
    control: controlTime,
    name: `slots.${activeDay}`,
  });

  // Offline Form
  const {
    register: registerOffline,
    handleSubmit: handleSubmitOffline,
    control: controlOffline,
    setValue: setValueOffline,
    watch: watchOffline,
    trigger: triggerOffline,
    formState: { errors: errorsOffline },
    reset: resetOffline,
  } = useForm({
    defaultValues: defaultValuesOffline,
  });

  const {
    fields: offlineFields,
    append: appendOffline,
    remove: removeOffline,
    replace: replaceOffline,
  } = useFieldArray({
    control: controlOffline,
    name: `slots.${activeDay}`,
  });

  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      return obj.map(cleanObject).filter((item) => item !== undefined && Object.keys(item).length > 0);
    } else if (obj !== null && typeof obj === "object") {
      const newObj = {};
      for (const [key, value] of Object.entries(obj)) {
        const cleanedValue = cleanObject(value);
        if (
          cleanedValue !== null &&
          cleanedValue !== undefined &&
          cleanedValue !== "" &&
          !(typeof cleanedValue === "object" && Object.keys(cleanedValue).length === 0)
        ) {
          newObj[key] = cleanedValue;
        }
      }
      return Object.keys(newObj).length > 0 ? newObj : undefined;
    }
    return obj;
  }

  function cleanSchedule(schedule) {
    const cleaned = {};
    for (const [day, slots] of Object.entries(schedule)) {
      const cleanedSlots = cleanObject(slots);
      if (Array.isArray(cleanedSlots) && cleanedSlots.length > 0) {
        cleaned[day] = cleanedSlots;
      }
    }
    return cleaned;
  }
  function cleanSchedule(schedule) {
    const cleaned = {};
    for (const [day, slots] of Object.entries(schedule)) {
      const cleanedSlots = cleanObject(slots);
      if (Array.isArray(cleanedSlots) && cleanedSlots.length > 0) {
        cleaned[day] = cleanedSlots;
      }
    }
    return cleaned;
  }

  const onFormSubmitTime = (data) => {
    console.log(data, "data");
    const cleanedData = cleanSchedule(data?.slots);

    const isSynced = watchTime("to_all_time");

    let finalSlots = cleanedData;

    // if (isSynced === true) {
    //   const sourceSlots = cleanedData[activeDay] || [];

    //   finalSlots = DAYS.reduce((acc, day) => {
    //     acc[day] = sourceSlots;
    //     return acc;
    //   }, {});
    // }

    const body = {
      doctor_id: doctor.id,
      type: activeTab,
      sync: data?.to_all_time,
      slots: finalSlots,
    };

    createDoctorSlotAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          navigate(-1);
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const toTime = (e, day) => {
    const sync = e.target.checked;

    // Update checkbox state
    setValueTime("to_all_time", sync, {
      shouldDirty: true,
      shouldValidate: true,
    });

    // If sync is turned on → Copy active day slots to ALL DAYS
    if (sync) {
      const sourceSlots = watchTime(`slots.${day}`) || [];

      DAYS.forEach((d) => {
        setValueTime(`slots.${d}`, sourceSlots, {
          shouldDirty: true,
          shouldValidate: true,
        });
      });
    }
  };

  const toOffline = (e) => {
    const isChecked = e.target.checked;
    setValueOffline("to_all_offline", isChecked);
    const mondaySlots = watchOffline(`slots.${activeDay}`) || [];
    if (isChecked) {
      DAYS.forEach((day) => {
        if (day !== activeDay) {
          setValueOffline(`slots.${day}`, [...mondaySlots]);
        }
      });
    }
    //   else {

    //   DAYS.forEach((day) => {
    //     if (day !== activeDay) {
    //       setValueOffline(`slots.${day}`, []);
    //     }
    //   });
    // }
  };

  const handleAddTimeSlot = () => {
    let newSlot = { ...defaultSlotStructureTime };
    appendTime(newSlot);
  };

  const handleAddOfflineSlot = () => {
    let newSlot = { ...defaultSlotStructureOffline };
    appendOffline(newSlot);
  };

  const onFormSubmitOffline = (data) => {
    console.log(data, "daqtataaaa");

    const slotsData = data?.slots || {};
    const formData = new FormData();

    let clinicSlot = null;

    // for (const day of Object.keys(slotsData)) {
    //   const slot = slotsData[day]?.find((s) => s?.clinic_name && s?.pin_code);
    //   if (slot) {
    //     clinicSlot = slot;
    //     break;
    //   }
    // }

    // if (!clinicSlot) {
    //   toast.error("Clinic details required");
    //   return;
    // }

    // const clinic = {
    //   clinic_name: clinicSlot.clinic_name,
    //   clinic_address: clinicSlot.clinic_address,
    //   fees: clinicSlot.fees ?? "",
    //   emergency_fees: clinicSlot.emergency_fees ?? "",
    //   pin_code: clinicSlot.pin_code,
    //   city: clinicSlot.city,
    //   state: clinicSlot.state,
    //   slot_duration: clinicSlot.duration,
    //   clinic_id: clinicSlot.clinic_id || "",
    // };

    const slots = DAYS.map((day) => {
      const validSlots =
        slotsData?.[day]
          ?.filter((s) => s.start_time && s.end_time)
          ?.map((s) => ({
            start_time: s.start_time,
            end_time: s.end_time,
            duration: s.duration,
          })) || [];

      return {
        day,
        slots: validSlots.length ? validSlots : null,
      };
    });

    formData.append("slots", JSON.stringify(slots));
    formData.append("doctor_id", doctor?.id);
    formData.append("clinic[clinic_id]", data?.clinic_id);
    formData.append("clinic[phone]", data?.phone);
    formData.append("clinic[clinic_name]", data?.clinic_name);
    formData.append("clinic[clinic_address]", data?.clinic_address);
    formData.append("clinic[fees]", data?.fees);
    formData.append("clinic[pin_code]", data?.pin_code);
    formData.append("clinic[city]", data?.city);
    formData.append("clinic[state]", data?.state);
    formData.append("clinic[slot_duration]", data?.duration);

    // DAYS.forEach((day) => {
    //   const daySlots = slotsData?.[day] || [];

    // const imageSlot = data?..find(
    //   (s) => s?.image_url_1 instanceof File || s?.image_url_2 instanceof File || s?.image_url_3 instanceof File,
    // );

    // if (!imageSlot) return;

    if (data?.image_url_1 instanceof File) {
      formData.append(`clinic_images`, data?.image_url_1);
    }

    if (data?.image_url_2 instanceof File) {
      formData.append(`clinic_images`, data?.image_url_2);
    }
    if (data?.image_url_3 instanceof File) {
      formData.append(`clinic_images`, data?.image_url_3);
    }
    // });

    for (const pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    // const body = {
    //   clinic: clinic,
    //   slots: slots,
    //   doctor_id: doctor?.id,
    // };
    return createMultipleClinicOfflineAPI(formData)
      .then((res) => {
        toast.success(res.data.message);
        setSelectedRow([]);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getSlots();
  }, [activeTab]);

  const mapOfflineApiSlotsToForm = (apiSlots = [], clinic_img) => {
    return DAYS.reduce((acc, day) => {
      const daySlots = apiSlots
        .filter((slot) => slot.day === day)
        .map((slot) => {
          const images = Array.isArray(clinic_img) ? clinic_img : [];

          return {
            fees: slot.fees || "",
            clinic_name: slot.clinic_name || "",
            phone: slot.phone || "",
            clinic_address: slot.clinic_address || "",
            emergency_fees: slot.emergency_fees || "",
            pin_code: slot.pin_code || "",
            city: slot.city || "",
            state: slot.state || "",
            start_time: slot.start_time || "",
            end_time: slot.end_time || "",
            duration: slot.duration || "",
            whatsApp: slot.whatsApp || "",

            /* ---------- IMAGE MAPPING (FIXED) ---------- */
            image_url_1: images[0] || null,
            image_url_2: images[1] || null,
            image_url_3: images[2] || null,

            image_url_1_pre: images[0] ? `${BASE_URL_IMG}${images[0]}` : null,
            image_url_2_pre: images[1] ? `${BASE_URL_IMG}${images[1]}` : null,
            image_url_3_pre: images[2] ? `${BASE_URL_IMG}${images[2]}` : null,
            /* ------------------------------------------ */

            id: slot.id,
            clinic_id: slot.clinic_id || "",
          };
        });

      acc[day] = daySlots.length > 0 ? daySlots : [{ ...defaultSlotStructureOffline }];

      return acc;
    }, {});
  };

  const getSlots = () => {
    const body = {
      doctor_id: doctor?.id,
      type: activeTab,
    };

    setLoading(true);

    getDoctorSlotAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const apiSlots = res.data.data?.slots || {};
          const syncStatus = res.data.data?.sync || false;
          setApi(apiSlots);

          if (activeTab === "online1") {
            // resetOnline({
            //   slots: DAYS.reduce((acc, day) => {
            //     const slotsForDay = (apiSlots[day] || []).map((slot) => ({
            //       start_time: slot.start_time || "",
            //       end_time: slot.end_time || "",
            //       duration: slot.duration || "",
            //       fees: slot.fees || "",
            //       whatsApp: slot.whatsApp || "",
            //       id: slot.id,
            //     }));

            //     if (slotsForDay.length === 0) {
            //       acc[day] = [{ ...defaultSlotStructureOnline }];
            //     } else {
            //       acc[day] = slotsForDay;
            //     }

            //     return acc;
            //   }, {}),
            //   to_all_online: syncStatus,
            // });
          } else if (activeTab === "offline") {
            setClinics(res.data.data || []);
          } else if (activeTab === "online_audio") {
            // resetOnlineVoiceCall({
            //   slots: DAYS.reduce((acc, day) => {
            //     const slotsForDay = (apiSlots[day] || []).map((slot) => ({
            //       start_time: slot.start_time || "",
            //       end_time: slot.end_time || "",
            //       duration: slot.duration || "",
            //       fees: slot.fees || "",
            //       whatsApp: slot.whatsApp || "",
            //       id: slot.id,
            //     }));

            //     if (slotsForDay.length === 0) {
            //       acc[day] = [{ ...defaultSlotStructureOnline }];
            //     } else {
            //       acc[day] = slotsForDay;
            //     }
            //     return acc;
            //   }, {}),
            //   to_all_online_audio: syncStatus,
            // });
          } else if (activeTab === "online") {
            resetTime({
              slots: DAYS.reduce((acc, day) => {
                const slotsForDay = (apiSlots[day] || []).map((slot) => ({
                  start_time: slot.start_time || "",
                  end_time: slot.end_time || "",
                  duration: slot.duration || "",
                  id: slot.id,
                }));

                if (slotsForDay.length === 0) {
                  acc[day] = [{ ...defaultSlotStructureTime }];
                } else {
                  acc[day] = slotsForDay;
                }

                return acc;
              }, {}),
              to_all_time: syncStatus,
            });
          }
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(res.data.message);
          if (res.data.status === "expired") logout();
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    // if (!Array.isArray(watchedSlots)) return;

    // watchedSlots.forEach((slot, index) => {
    if (watchOffline("pin_code") && watchOffline("pin_code").length === 6) {
      getZipDetails(watchOffline("pin_code"));
    }
    // });
  }, [watchOffline("pin_code")]);

  const getZipDetails = (pinCode, index) => {
    const body = { pin_code: pinCode };

    getZipDetailsAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const { district_name, state_name } = res.data.data;

          setValueOffline(`city`, district_name, {
            shouldDirty: true,
            shouldValidate: true,
          });

          setValueOffline(`state`, state_name, {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message));
  };

  const removeTimeR = (indexToRemove, day) => {
    const existingSlots = watchTime(`slots.${day}`) || [];

    // Remove the slot at the given index
    const updatedSlots = existingSlots.filter((_, idx) => idx !== indexToRemove);

    // Update form state
    setValueTime(`slots.${day}`, updatedSlots);
    triggerTime(`slots.${day}`);

    console.log(
      "Updated slots:",
      { before: existingSlots, after: updatedSlots },
      "Day:",
      day,
      "Removed index:",
      indexToRemove,
    );
  };

  const selectedClinic = (data) => {
    setIsClinicOpen(true);
    const apiFlatSlots = data?.slots || [];
    const syncStatus = data?.sync || false;
    const formattedSlots = mapOfflineApiSlotsToForm(apiFlatSlots, data?.clinic_images);
    setSelectedRow(data);
    resetOffline({
      slots: formattedSlots,
      to_all_offline: syncStatus,
    });
    const images = Array.isArray(data?.clinic_images) ? data?.clinic_images : [];
    setValueOffline("clinic_name", data?.clinic_name || "");
    setValueOffline("phone", data?.phone || "");
    setValueOffline("duration", data?.slots[0]?.duration || "");
    setValueOffline("pin_code", data?.pin_code || "");
    setValueOffline("fees", data?.fees || "");
    setValueOffline("clinic_id", data?.id || "");
    setValueOffline("clinic_address", data?.clinic_address || "");
    setValueOffline("image_url_1_pre", images[0] ? `${BASE_URL_IMG}${images[0]}` : null);
    setValueOffline("image_url_2_pre", images[1] ? `${BASE_URL_IMG}${images[1]}` : null);
    setValueOffline("image_url_3_pre", images[2] ? `${BASE_URL_IMG}${images[2]}` : null);
  };
  const handleRemoveOffline = (data) => {
    setSelectedRow(data);
    setClinicRemoveConfirm(true);
  };
  const removeConfirmCLinic = () => {
    const body = { id: selectedRow?.clinic_id || selectedRow?.id, session_type: "offline" };
    removeClinicAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setIsClinicOpen(false);
          resetOffline({
            slots: [],
            to_all_offline: false,
          });
          setSelectedRow([]);
          getSlots();
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message));
  };
  const removeTimeOffline = (indexToRemove, day) => {
    const existingSlots = watchOffline(`slots.${day}`) || [];
    // Remove the slot at the given index
    const updatedSlots = existingSlots.filter((_, idx) => idx !== indexToRemove);
    // Update form state
    setValueOffline(`slots.${day}`, updatedSlots);
    triggerOffline(`slots.${day}`);
  };

  const timeStringToDate = (time) => {
    if (!time) {
      return null;
    }

    const [hours, minutes] = time
      .split(":")
      .map(Number);

    const date = new Date();

    date.setHours(
      hours || 0,
      minutes || 0,
      0,
      0
    );

    return date;
  };


  const dateToTimeString = (date) => {
    if (!date) {
      return "";
    }

    const hours = String(
      date.getHours()
    ).padStart(2, "0");

    const minutes = String(
      date.getMinutes()
    ).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  return (
    <>
      <Head title="Doctor | Slot Management" />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Doctor Slot Management"}
              </BlockTitle>
            </BlockHeadContent>

            {location?.state == null ? null : (
              <BlockHeadContent>
                <div className="">
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      navigate("/doctor/list");
                    }}
                  >
                    <Icon name={"arrow-left"} />
                  </Button>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>
        <Block>
          <Col md="3">
            <PreviewAltCard>
              <div className="team">
                <div
                  className={`team-status ${doctor?.status === "Active"
                    ? "bg-success text-white"
                    : doctor?.status === "Pending"
                      ? "bg-warning text-white"
                      : "bg-danger text-white"
                    } `}
                >
                  <Icon
                    name={`${doctor?.status === "Active" ? "check-thick" : doctor?.status === "Pending" ? "clock" : "na"
                      }`}
                  ></Icon>
                </div>
                <div className="team-options"></div>
                <div className="user-card user-card-s2">
                  <UserAvatar
                    theme={doctor?.avatarBg}
                    className="md"
                    text={findUpper(doctor?.name)}
                    image={doctor?.image}
                  >
                    <div className="status dot dot-lg dot-success"></div>
                  </UserAvatar>
                  <div className="user-info">
                    <h6>{doctor?.name}</h6>
                    <span className="sub-text">@{doctor?.name.split(" ")[0].toLowerCase()}</span>
                    <h6>{doctor?.mobile}</h6>
                  </div>
                </div>

                <div className="team-view">
                  <Link
                    to={{
                      pathname: `${process.env.PUBLIC_URL}/doctor/detail`,
                    }}
                    state={{ doctor_id: doctor?.id }}
                  >
                    <Button outline color="light" className="btn-round w-150px">
                      <span>View Profile</span>
                    </Button>
                  </Link>
                </div>
              </div>
            </PreviewAltCard>
          </Col>
          <Col md={12}>
            <Nav tabs className="nav-tabs-s2">
              <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === "offline" })}
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggle("offline");
                  }}
                >
                  Offline
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === "online1" })}
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggle("online1");
                  }}
                >
                  Video Call
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === "online_audio" })}
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggle("online_audio");
                  }}
                >
                  Audio Call
                </NavLink>
              </NavItem> */}
              <NavLink
                tag="a"
                href="#tab"
                className={classnames({ active: activeTab === "online" })}
                onClick={(ev) => {
                  ev.preventDefault();
                  toggle("online");
                }}
              >
                Timing
              </NavLink>
            </Nav>
          </Col>
          <TabContent activeTab={activeTab}>
            {/* Offline Tab */}

            <TabPane tabId="offline">
              <PreviewAltCard>
                {loading ? (
                  <MyLoader />
                ) : (
                  <>
                    {clinics?.length == 3 ? (
                      <>
                        {isClinicOpen && (
                          <div className="my-2 text-end">
                            <Button
                              type="button"
                              size="sm"
                              color="secondary"
                              outline
                              onClick={() => {
                                setIsClinicOpen((pre) => !pre);
                                if (isClinicOpen) {
                                  console.log("reset ");
                                  resetOffline({
                                    slots: [],
                                    to_all_offline: false,
                                  });
                                }
                              }}
                            >
                              {"Close"} Clinic
                            </Button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="my-2 text-end">
                        <Button
                          type="button"
                          size="sm"
                          color="secondary"
                          outline
                          onClick={() => {
                            setIsClinicOpen((pre) => !pre);
                            if (isClinicOpen) {
                              resetOffline({
                                slots: [
                                  {
                                    ...defaultSlotStructureOffline,
                                  },
                                ],
                                to_all_offline: false,
                              });
                            } else {
                              setValueOffline(`slots.monday.${0}.start_time`);
                              setValueOffline(`slots.monday.${0}.end_time`);
                            }
                          }}
                        >
                          {isClinicOpen ? "Close" : "Add"} Clinic
                        </Button>
                      </div>
                    )}
                    {isClinicOpen ? (
                      <Form onSubmit={handleSubmitOffline(onFormSubmitOffline)}>
                        <Row>
                          <div className="d-flex gap-5 mb-3">
                            <h5>{"Clinic/Hospital"}</h5>
                          </div>
                          <Row className={"mb-3"}>
                            <Col md={3}>
                              <div className="form-group my-2">
                                <label className="form-label fw-semibold">Clinic Name</label>
                                <input
                                  type="text"
                                  placeholder="Enter clinic name"
                                  {...registerOffline(`clinic_name`, {
                                    required: "Clinic name is required",
                                    pattern: {
                                      value: /^[A-Za-z0-9_\/]+(?: [A-Za-z0-9_\/]+)*$/,
                                      message:
                                        "Only letters, numbers, underscore (_), slash (/) and single spaces between words are allowed",
                                    },
                                  })}
                                  className="form-control"
                                />
                                {errorsOffline?.clinic_name && (
                                  <small className="text-danger">{errorsOffline.clinic_name.message}</small>
                                )}
                              </div>
                            </Col>
                            <Col md="3" className={``}>
                              <MyMobile
                                register={registerOffline}
                                watch={watchOffline}
                                setValue={setValueOffline}
                                trigger={triggerOffline}
                                errors={errorsOffline}
                                title={"Phone"}
                                name={"phone"}
                                placeholder={"Enter Phone"}
                                required
                              />
                            </Col>
                            <Col md={2}>
                              <div className="form-group my-2">
                                <label className="form-label fw-semibold">Duration</label>
                                <select
                                  {...registerOffline(`duration`, {
                                    required: "duration is required",
                                  })}
                                  className="form-select"
                                // defaultValue={field?.duration || ""}
                                >
                                  <option value="">Select Duration</option>
                                  {slotDuration.map((s) => (
                                    <option key={s.value || s.label} value={s.value || s.label}>
                                      {s.label}
                                    </option>
                                  ))}
                                </select>
                                {errorsOffline?.slots?.duration && (
                                  <p style={{ fontSize: "10px" }} className="text-danger">
                                    {errorsOffline.duration.message}
                                  </p>
                                )}
                              </div>
                            </Col>
                            <Col md={1}>
                              <div className="form-group my-2">
                                <label className="form-label fw-semibold">Fees</label>
                                <input
                                  type="text"
                                  placeholder="Enter consultation fees"
                                  {...registerOffline(`fees`, {
                                    // required: "Fees is required",
                                    // pattern: {
                                    //   value: /^[0-9]+$/,
                                    //   message: "Fees must be a valid number",
                                    // },
                                  })}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                  }}
                                  className="form-control"
                                />

                                {errorsOffline?.fees && (
                                  <small className="text-danger">{errorsOffline.fees.message}</small>
                                )}
                              </div>
                            </Col>
                            <Col md={2}>
                              <div className="form-group my-2">
                                {" "}
                                <label className="form-label fw-semibold">Pin Code</label>
                                <input
                                  type="text"
                                  placeholder="Enter pin code"
                                  maxLength={6}
                                  {...registerOffline(`pin_code`, {
                                    required: "Pin code is required",
                                    pattern: {
                                      value: /^[0-9]{6}$/,
                                      message: "Pin code must be exactly 6 digits",
                                    },
                                    minLength: {
                                      value: 6,
                                      message: "Pin code must be 6 digits",
                                    },
                                    maxLength: {
                                      value: 6,
                                      message: "Pin code must be 6 digits",
                                    },
                                  })}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                  }}
                                  className="form-control"
                                />
                                {errorsOffline?.pin_code && (
                                  <small className="text-danger">{errorsOffline.pin_code.message}</small>
                                )}
                              </div>
                            </Col>
                            <Col md={2}>
                              <div className="form-group my-2">
                                <label className="form-label fw-semibold">City</label>
                                <input
                                  type="text"
                                  placeholder="Enter city"
                                  {...registerOffline(`city`, {})}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                  }}
                                  className="form-control"
                                  readOnly
                                />

                                {errorsOffline?.city && (
                                  <small className="text-danger">{errorsOffline.city.message}</small>
                                )}
                              </div>
                            </Col>
                            <Col md={2}>
                              <div className="form-group my-2">
                                <label className="form-label fw-semibold">State</label>
                                <input
                                  type="text"
                                  placeholder="Enter state"
                                  {...registerOffline(`state`, {})}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                  }}
                                  readOnly
                                  className="form-control"
                                />

                                {errorsOffline.state && (
                                  <small className="text-danger">{errorsOffline.state.message}</small>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <Row>
                                <Col md={4}>
                                  <div className="form-group my-2">
                                    <label className="form-label fw-semibold">Clinic Image 1</label>
                                    <CenterImage
                                      onChange={(data) => {
                                        setValueOffline(`image_url_1`, data.file);
                                        setValueOffline(`image_url_1_pre`, data.previewUrl);
                                      }}
                                      currentImage={watchOffline(`image_url_1_pre`)}
                                    />
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <div className="form-group my-2">
                                    <label className="form-label fw-semibold">Clinic Image 2</label>
                                    <CenterImage
                                      onChange={(data) => {
                                        setValueOffline(`image_url_2`, data.file);
                                        setValueOffline(`image_url_2_pre`, data.previewUrl);
                                      }}
                                      currentImage={watchOffline(`image_url_2_pre`)}
                                    />
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <div className="form-group my-2">
                                    <label className="form-label fw-semibold">Clinic Image 3</label>
                                    <CenterImage
                                      onChange={(data) => {
                                        setValueOffline(`image_url_3`, data.file);
                                        setValueOffline(`image_url_3_pre`, data.previewUrl);
                                      }}
                                      currentImage={watchOffline(`image_url_3_pre`)}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>

                            <Col md={6}>
                              <div className="form-group my-2">
                                <label className="form-label fw-semibold">Full Address</label>
                                <textarea
                                  {...registerOffline(`clinic_address`, {
                                    required: "Address is required",
                                  })}
                                  className="form-control"
                                  placeholder="Enter full clinic address"
                                  rows="3"
                                />
                                {errorsOffline?.clinic_address && (
                                  <small className="text-danger">{errorsOffline.clinic_address.message}</small>
                                )}
                              </div>
                            </Col>
                          </Row>

                          <Col md={12}>
                            <ul className="nav nav-pills mb-3 flex-wrap mx-1">
                              {DAYS.map((day) => (
                                <li className="nav-item me-2 mb-2" key={day}>
                                  <button
                                    type="button"
                                    onClick={() => setActiveDay(day)}
                                    className={`btn btn-sm ${activeDay === day ? "btn-primary" : "btn-outline-primary"
                                      } text-capitalize`}
                                  >
                                    {day}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </Col>

                          <Col md={2}>
                            <div className="ms-2 form-control-wrap">
                              <div className="d-flex justify-content-start align-items-center">
                                <input
                                  type="checkbox"
                                  id={"to_all_offline"}
                                  {...registerOffline("to_all_offline")}
                                  className="form-check my-1"
                                  checked={watchOffline("to_all_offline")}
                                  onChange={(e) => toOffline(e, `${activeDay}`)}
                                />
                                <span htmlFor={"to_all_offline"} className="mx-1 my-1">
                                  {"sync all days"}
                                </span>
                                {watchOffline("to_all_offline") && (
                                  <span className="badge bg-warning ms-2">All days synced</span>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col>
                            <div key={activeDay}>
                              {watchOffline(`slots.${activeDay}`)?.length === 0 && (
                                <p className="text-muted small">
                                  No clinic/hospital added yet. Click below to add one.
                                </p>
                              )}

                              {watchOffline(`slots.${activeDay}`)?.map((field, index) => {
                                const startTime = watchOffline(
                                  `slots.${activeDay}.${index}.start_time`
                                );

                                const endTime = watchOffline(
                                  `slots.${activeDay}.${index}.end_time`
                                );

                                return (
                                  <div
                                    className="card mb-3 border-0 shadow-sm"
                                    key={field.id}
                                  >
                                    <div className="card-body">

                                      {/* ================================
            SLOT HEADER
        ================================= */}

                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="mb-0">
                                          Slot {index + 1}
                                        </h5>

                                        <button
                                          type="button"
                                          onClick={() =>
                                            removeTimeOffline(
                                              index,
                                              activeDay
                                            )
                                          }
                                          className="btn btn-outline-danger btn-sm"
                                        >
                                          Remove
                                        </button>
                                      </div>

                                      <Row>

                                        {/* ================================
              START TIME
          ================================= */}

                                        <Col md={3}>
                                          <div className="form-group my-2">

                                            <label className="form-label fw-semibold">
                                              Start Time
                                            </label>

                                            <DatePicker
                                              selected={timeStringToDate(
                                                startTime
                                              )}

                                              onChange={(date) => {
                                                const value =
                                                  dateToTimeString(
                                                    date
                                                  );

                                                setValueOffline(
                                                  `slots.${activeDay}.${index}.start_time`,
                                                  value,
                                                  {
                                                    shouldValidate: true,
                                                    shouldDirty: true,
                                                  }
                                                );
                                              }}

                                              showTimeSelect
                                              showTimeSelectOnly

                                              timeIntervals={15}

                                              timeCaption="Time"

                                              dateFormat="h:mm aa"

                                              className="form-control"

                                              placeholderText="Select start time"

                                              isClearable={false}

                                              popperPlacement="bottom-start"

                                              portalId="root"
                                            />

                                            {errorsOffline
                                              ?.slots?.[activeDay]?.[index]
                                              ?.start_time && (
                                                <small className="text-danger">
                                                  {
                                                    errorsOffline
                                                      .slots[
                                                      activeDay
                                                    ][index]
                                                      .start_time
                                                      .message
                                                  }
                                                </small>
                                              )}

                                          </div>
                                        </Col>


                                        {/* ================================
              END TIME
          ================================= */}

                                        <Col md={3}>
                                          <div className="form-group my-2">

                                            <label className="form-label fw-semibold">
                                              End Time
                                            </label>

                                            <DatePicker
                                              selected={timeStringToDate(
                                                endTime
                                              )}

                                              onChange={(date) => {
                                                const value =
                                                  dateToTimeString(
                                                    date
                                                  );

                                                setValueOffline(
                                                  `slots.${activeDay}.${index}.end_time`,
                                                  value,
                                                  {
                                                    shouldValidate: true,
                                                    shouldDirty: true,
                                                  }
                                                );
                                              }}

                                              showTimeSelect
                                              showTimeSelectOnly

                                              timeIntervals={15}

                                              timeCaption="Time"

                                              dateFormat="h:mm aa"

                                              className="form-control"

                                              placeholderText="Select end time"

                                              isClearable={false}

                                              popperPlacement="bottom-start"

                                              portalId="root"
                                            />

                                            {errorsOffline
                                              ?.slots?.[activeDay]?.[index]
                                              ?.end_time && (
                                                <small className="text-danger">
                                                  {
                                                    errorsOffline
                                                      .slots[
                                                      activeDay
                                                    ][index]
                                                      .end_time
                                                      .message
                                                  }
                                                </small>
                                              )}

                                          </div>
                                        </Col>

                                      </Row>
                                    </div>
                                  </div>
                                );
                              })}
                              {
                                <div className="">
                                  <Button className="btn btn-primary" type="button" onClick={handleAddOfflineSlot}>
                                    + Add
                                  </Button>
                                </div>
                              }

                              <div className="d-flex justify-content-end mt-3">
                                <button type="submit" className="btn btn-primary text-end">
                                  Save
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    ) : (
                      <>
                        {clinics?.length > 0 ? (
                          <div className="d-flex ">
                            {clinics?.map((item, index) => (
                              <Card key={index} className="card-bordered me-2">
                                <div className="d-flex justify-content-end">
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    className="mt-1 mx-1"
                                    onClick={() => selectedClinic(item)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    // onClick={() => removeOffline(index)}
                                    onClick={() => handleRemoveOffline(item)}
                                    size="xs"
                                    color="danger"
                                    outline
                                    className="mt-1 "
                                  >
                                    Remove
                                  </Button>
                                </div>
                                {/* <CardImg top src={item?.img||""} alt="" /> */}
                                <CardBody className="card-inner">
                                  <CardTitle tag="h5">{item?.clinic_name || "clinic name"}</CardTitle>
                                  <CardTitle tag="h5">{item?.phone || "phone name"}</CardTitle>
                                  <CardText>{item?.clinic_address || ""}</CardText>

                                  <div className="days">
                                    {item?.slots ? (
                                      item?.slots?.map((day) => (
                                        <Badge color="outline-primary" key={day?.day} className="me-1 text-capitalize">
                                          {day?.day}
                                        </Badge>
                                      ))
                                    ) : (
                                      <span className="text-muted">No availability</span>
                                    )}
                                  </div>
                                </CardBody>
                              </Card>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center py-5">
                            <h5 className="fw-semibold mb-2">You haven’t added any clinics yet</h5>
                            <p className="text-muted mb-3">
                              Add your clinic details and availability so patients can book appointments.
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </PreviewAltCard>
            </TabPane>

            {/* Timing  Tab */}
            <TabPane tabId="online">
              <PreviewAltCard>
                {loading ? (
                  <MyLoader />
                ) : (
                  <Form onSubmit={handleSubmitTime(onFormSubmitTime)}>
                    <Row>
                      <div className="d-flex gap-5 mb-3">
                        <h5>{"Slots"}</h5>
                      </div>

                      <Col md={12}>
                        <ul className="nav nav-pills mb-3 flex-wrap mx-1">
                          {DAYS.map((day) => (
                            <li className="nav-item me-2 mb-2" key={day}>
                              <button
                                type="button"
                                onClick={() => setActiveDay(day)}
                                className={`btn btn-sm ${activeDay === day ? "btn-primary" : "btn-outline-primary"
                                  } text-capitalize`}
                              >
                                {day}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </Col>
                      <Col md={2}>
                        <div className=" ms-2 form-control-wrap ">
                          <div className="d-flex justify-content-start">
                            <input
                              type="checkbox"
                              id={"to_all_time"}
                              {...registerTime("to_all_time", {})}
                              className="form-check "
                              checked={watchTime("to_all_time")}
                              onChange={(e) => toTime(e, `${activeDay}`)}
                            />
                            <span htmlFor={"to_all_time"} className="mx-1 my-1">
                              {"sync all days"}
                            </span>
                            {/* {watchOnline("to_all_online") && (
                              <span className="badge bg-warning ms-2">All days synced</span>
                            )} */}
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div key={activeDay}>
                          {watchTime(`slots.${activeDay}`)?.length === 0 && (
                            <p className="text-muted small">
                              No sessions added yet for <b>{activeDay}</b>. Click below to add one.
                            </p>
                          )}

                          <Row>
                            {watchTime(`slots.${activeDay}`)?.map((field, index) => {
                              const startTime = getValueTime(
                                `slots.${activeDay}.${index}.start_time`
                              );

                              const endTime = getValueTime(
                                `slots.${activeDay}.${index}.end_time`
                              );

                              return (
                                <Col md="3" key={field.id || index}>
                                  <div className="card mb-3 border-0 shadow-sm">
                                    <div className="card-body">

                                      {/* =========================
              SESSION HEADER
          ========================== */}

                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="mb-0">
                                          Session {index + 1}
                                        </h5>

                                        <button
                                          type="button"
                                          onClick={() =>
                                            removeTimeR(index, activeDay)
                                          }
                                          className="btn btn-outline-danger btn-sm"
                                        >
                                          Remove
                                        </button>
                                      </div>

                                      <Row>

                                        {/* =========================
                START TIME
            ========================== */}

                                        <Col md={6}>
                                          <div className="form-group my-2">

                                            <label className="form-label fw-semibold">
                                              Start Time
                                            </label>

                                            <DatePicker
                                              selected={timeStringToDate(startTime)}

                                              onChange={(date) => {
                                                const value = dateToTimeString(date);

                                                setValueTime(
                                                  `slots.${activeDay}.${index}.start_time`,
                                                  value,
                                                  {
                                                    shouldValidate: true,
                                                    shouldDirty: true,
                                                  }
                                                );

                                                // Revalidate end time
                                                triggerTime(
                                                  `slots.${activeDay}.${index}.end_time`
                                                );
                                              }}

                                              showTimeSelect
                                              showTimeSelectOnly

                                              timeIntervals={15}

                                              timeCaption="Time"

                                              dateFormat="h:mm aa"

                                              className="form-control"

                                              placeholderText="Select start time"

                                              isClearable={false}

                                              popperPlacement="bottom-start"

                                              portalId="root"
                                            />

                                            {errorsTime
                                              ?.slots?.[activeDay]?.[index]
                                              ?.start_time && (
                                                <p
                                                  style={{ fontSize: "10px" }}
                                                  className="text-danger mb-0"
                                                >
                                                  {
                                                    errorsTime
                                                      .slots[activeDay][index]
                                                      .start_time.message
                                                  }
                                                </p>
                                              )}

                                          </div>
                                        </Col>


                                        {/* =========================
                END TIME
            ========================== */}

                                        <Col md={6}>
                                          <div className="form-group my-2">

                                            <label className="form-label fw-semibold">
                                              End Time
                                            </label>

                                            <DatePicker
                                              selected={timeStringToDate(endTime)}

                                              onChange={(date) => {
                                                const value = dateToTimeString(date);

                                                setValueTime(
                                                  `slots.${activeDay}.${index}.end_time`,
                                                  value,
                                                  {
                                                    shouldValidate: true,
                                                    shouldDirty: true,
                                                  }
                                                );

                                                triggerTime(
                                                  `slots.${activeDay}.${index}.end_time`
                                                );
                                              }}

                                              showTimeSelect
                                              showTimeSelectOnly

                                              timeIntervals={15}

                                              timeCaption="Time"

                                              dateFormat="h:mm aa"

                                              className="form-control"

                                              placeholderText="Select end time"

                                              isClearable={false}

                                              popperPlacement="bottom-start"

                                              portalId="root"

                                              minTime={
                                                startTime
                                                  ? timeStringToDate(startTime)
                                                  : undefined
                                              }

                                              maxTime={timeStringToDate("23:45")}
                                            />

                                            {errorsTime
                                              ?.slots?.[activeDay]?.[index]
                                              ?.end_time && (
                                                <p
                                                  style={{ fontSize: "10px" }}
                                                  className="text-danger mb-0"
                                                >
                                                  {
                                                    errorsTime
                                                      .slots[activeDay][index]
                                                      .end_time.message
                                                  }
                                                </p>
                                              )}

                                          </div>
                                        </Col>


                                        {/* =========================
                DURATION
            ========================== */}

                                        <Col md={6}>
                                          <div className="form-group my-2">

                                            <label className="form-label fw-semibold">
                                              Duration
                                            </label>

                                            <select
                                              {...registerTime(
                                                `slots.${activeDay}.${index}.duration`,
                                                {
                                                  required:
                                                    "duration is required",
                                                }
                                              )}
                                              className="form-select"
                                            >
                                              <option value="">
                                                Select Duration
                                              </option>

                                              {slotDuration.map((s) => (
                                                <option
                                                  key={
                                                    s.value ||
                                                    s.label
                                                  }
                                                  value={
                                                    s.value ||
                                                    s.label
                                                  }
                                                >
                                                  {s.label}
                                                </option>
                                              ))}
                                            </select>

                                            {errorsTime
                                              ?.slots?.[activeDay]?.[index]
                                              ?.duration && (
                                                <p
                                                  style={{
                                                    fontSize: "10px",
                                                  }}
                                                  className="text-danger mb-0"
                                                >
                                                  {
                                                    errorsTime
                                                      .slots[activeDay][index]
                                                      .duration.message
                                                  }
                                                </p>
                                              )}

                                          </div>
                                        </Col>

                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>

                          <div className="d-flex justify-content-between mt-3">
                            <Button className="btn btn-primary" type="button" onClick={handleAddTimeSlot}>
                              + Add
                            </Button>

                            <button className="btn btn-primary">Save</button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </PreviewAltCard>
            </TabPane>
          </TabContent>
        </Block>
      </Content>

      <DeleteModal
        isOpen={clinicRemoveConfirm}
        toggle={() => setClinicRemoveConfirm(false)}
        data={selectedRow}
        title={selectedRow?.clinic_name}
        onConfirm={removeConfirmCLinic}
      />
    </>
  );
};

export default DoctorSlotForm;
